.dropdown-atom {
  position: relative;
  font-family: "DM Sans", sans-serif, "Arial";
  font-size: 14px;
  min-width: 120px;

  &__trigger {
    width: 100%;
    border: 1px solid var(--color-border-primary);
    border-radius: 2px;
    background: var(--color-bg-primary);
    color: var(--color-text-primary);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background: var(--color-bg-primary-hover);
    }

    &:hover .dropdown-atom__chevron {
      color: inherit;
    }
  }

  &__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &--placeholder {
      color: var(--color-text-primary);
    }
  }

  &__chevron {
    font-size: 16px;
    transition: transform 0.2s ease-in-out, color 0.2s ease-in-out;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__list {
    z-index: 1000;
    border: 1px solid var(--color-border-primary-disabled);
    border-radius: 2px;
    background: var(--color-bg-primary);
    box-shadow:
      0 2px 6px rgb(15 23 42 / 12%),
      0 12px 28px rgb(15 23 42 / 16%);
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow-y: auto;
  }

  &__option {
    border: none;
    border-radius: 2px;
    background: transparent;
    color: var(--color-text-primary);
    text-align: left;
    padding: 4px 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;

    &:hover {
      background: #f7f7f8;
    }

    &--selected {
      background: var(--color-bg-primary-selected);
      color: var(--color-text-brand);
    }

    &--disabled {
      color: var(--color-text-disabled-on-light);
      cursor: not-allowed;
    }
  }

  &__option-check {
    font-size: 16px;
    opacity: 0;
    width: 14px;
    transition: opacity 0.2s ease-in-out;

    &--visible {
      opacity: 1;
    }
  }

  &__option-check.material-icons {
    font-size: 16px !important;
    line-height: 1;
  }

  &--disabled &__trigger {
    cursor: not-allowed;
    background: var(--color-bg-primary-disabled);
    border-color: var(--color-border-primary-disabled);
    color: var(--color-text-disabled-on-light);

    &:hover {
      background: var(--color-bg-primary-disabled);
    }
  }

  &--error &__trigger {
    border-color: var(--color-border-primary-error);
  }
}
